var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ImageSettings',{attrs:{"row":_vm.row}}),_c('hr',{staticClass:"my-5"}),_c('TextboxSettings',{attrs:{"row":_vm.row}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }